import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { PRICE, FULL_PRICE } from '../data/content';
import { CtaButton } from './ui/CtaButton';
import { CountdownPill } from './ui/CountdownPill';
import { useCountdown } from '../hooks/useCountdown';
export function StickyCta() {
  const [visible, setVisible] = useState(false);
  const reduceMotion = useReducedMotion();
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 700);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-251" data-mp="3kkfxr2aan52q">
      {visible}
    </AnimatePresence>;
}